// 조직 감사 로그 (IMP-28) — 백엔드 kr.taplink.audit.TenantAuditController
//
// ⚠️ 테넌트 ID 를 보내지 않는다. 서버가 JWT 에서 읽는다 — 보내면 남의 조직을 조회할 수 있다.
import type { Schemas } from "@taplink/api-client";
import { request } from "@taplink/web-shared";

export type AuditPage = Schemas["AuditPage"];
export type AuditItem = Schemas["AuditLogItem"];

export const tenantAuditApi = {
  /**
   * @param range `&from=…&to=…` 형태의 질의 조각. web-shared 의 auditRangeToQuery 가 만든다 —
   *   두 콘솔이 **같은 방식**으로 조립해야 한다(따로 만들면 한쪽만 하루 밀린다).
   */
  search: (action: string | undefined, page: number, size = 30, range = "") =>
    request<AuditPage>(
      `/tenants/current/audit?page=${page}&size=${size}` +
        (action ? `&action=${encodeURIComponent(action)}` : "") +
        range,
    ),
};

/* ⚠️ AUDIT_LABELS 는 여기서 지웠다. 표가 두 벌이면 한쪽만 고치는 사고가 난다 —
   실제로 ENTITLEMENT_CHANGED · PLAN_CHANGED 같은 코드가 이 화면에 영어로 나오고
   있었다(운영자 콘솔 표에는 있었다). 이제 web-shared/auditLabels.ts 한 곳만 본다. */
